import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cbb6f80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-18 ant-col-xl-18" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-table-column-title" }
const _hoisted_6 = { class: "ant-table-column-sorter ant-table-column-sorter-full" }
const _hoisted_7 = { class: "ant-table-column-sorter-inner ant-table-column-sorter-inner-full" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "Ordenar crescente",
  class: "anticon anticon-caret-up ant-table-column-sorter-up"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-up",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "caret-down",
  class: "anticon anticon-caret-down ant-table-column-sorter-down"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-down",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" })
  ])
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 3,
  class: "ss-table-apresentacao-mobile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_busca_avancada = _resolveComponent("busca-avancada")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1300,
    centered: "",
    "wrap-class-name": "ss-modal-compras",
    destroyOnClose: true
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.props.tituloTela), 1)
      ])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmar()))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                style: {"margin-bottom":"5px","margin-top":"5px"},
                description: "Só é possível selecionar itens de pedido de compras que estão confirmados",
                type: "info",
                "show-icon": "",
                closable: ""
              }),
              _createVNode(_component_busca_avancada, {
                style: {"margin-left":"0px","margin-right":"0px"},
                buscaAvancada: _ctx.state.buscaAvancada,
                "onUpdate:buscaAvancada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.buscaAvancada) = $event)),
                visivel: true,
                empresas: [_ctx.props.empresa],
                onAplicarFiltros: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscarItens()))
              }, null, 8, ["buscaAvancada", "empresas"])
            ]),
            _: 1
          }),
          _createVNode(_component_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                "data-source": _ctx.state.itens,
                rowKey: "codigo",
                pagination: false,
                loading: _ctx.telaBase.carregando,
                scroll: _ctx.gradeBase.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth), y: _ctx.window.innerHeight - 300 },
                "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
                size: "small"
              }, {
                headerCell: _withCtx(({ column }) => [
                  (column.ordering)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: column.key,
                        class: "ss-coluna-ordenada"
                      }, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(column.title), 1),
                        _createElementVNode("span", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            (_openBlock(), _createElementBlock("a", {
                              title: "Ordenação crescente",
                              key: 'ord-asc' + column.key,
                              class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'ASC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                              onClick: ($event: any) => (_ctx.ordenarDados(column.key,'ASC'))
                            }, _hoisted_10, 10, _hoisted_8)),
                            (_openBlock(), _createElementBlock("a", {
                              title: "Ordenação decrescente",
                              key: 'ord-desc' + column.key,
                              class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'DESC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                              onClick: ($event: any) => (_ctx.ordenarDados(column.key,'DESC'))
                            }, _hoisted_13, 10, _hoisted_11))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                bodyCell: _withCtx(({ column, record, text }) => [
                  (column.key === 'Status')
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        class: _normalizeClass('ss-tag-status ' + _ctx.obterClasseStatus(text))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                        : (column.key === 'ItemPedido')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("span", null, _toDisplayString(record.descricaoProduto), 1),
                              _createElementVNode("span", null, "Quantidade: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, 2)) + "(" + _toDisplayString(record.descricaoUnidade) + ") ", 1),
                              _createElementVNode("span", null, "Vlr Unitário: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorUnitario, 2, true)), 1),
                              _createElementVNode("span", null, "Desconto: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.desconto, 2, true)), 1),
                              _createElementVNode("span", null, "Total: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal, 2, true)), 1)
                            ]))
                          : _createCommentVNode("", true)
                ]),
                emptyText: _withCtx(() => [
                  _createVNode(_component_mensagem_sem_dados, {
                    resultadoPesquisa: !_ctx.telaBase.carregando,
                    mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhum título foi encontrado com estes filtros!'
                  }, null, 8, ["resultadoPesquisa", "mensagem"])
                ]),
                _: 1
              }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}